const routes = [
    {
      path: '/supplier/landing',
      name: 'SupplierLanding',
      component: () => import('../../views/supplier/landing/LandingPage.vue')
    },
]

export default routes;